// Un seul PDF sert à l'affichage et au téléchargement : aucune version
// haute définition n'a été fournie pour cette édition.
export const PDF_NAME = 'LUCIOLE_PORFOLIO_SANTE_2026_20261007.pdf';
export const PDF_NAME_MOBILE = 'LUCIOLE_PORFOLIO_SANTE_2026_20261007.pdf';
export const PDF_NAME_HR = 'LUCIOLE_PORFOLIO_SANTE_2026_20261007.pdf';

export const SKIP_ANIMATION_STORAGE_KEY = 'SKIP_ANIMATION';

export const MENU_DESKTOP_WIDTH = 300;
export const MENU_MOBILE_HEADER_HEIGHT = 85;
export const MENU_MOBILE_FOOTER_HEIGHT = 75;
export const NAVIGATION_HEIGHT = 52;
export const MOBILE_NAVIGATION_HEIGHT = 40;
export const PDF_PAGE_RATIO = 339 / 190;
export const MODE_SINGLE_PAGE = false;
export const TITLE_LOADER = 'LUCIOLE';
export const PRESENTATION_TEXT = "Informer, sensibiliser, mobiliser. Nous accompagnons les acteurs de la santé dans la conception de communications claires, utiles et porteuses de sens.";
export const DOWNLOAD_TEXT = 'Télécharger ce portfolio';
export const SHARE_TEXT = 'Partager ce portfolio';
export const SHARE_TEXT_FACEBOOK = 'Partager sur Facebook';
export const SHARE_TEXT_X = 'Partager sur X';
export const SHARE_TEXT_LINKEDIN = 'Partager sur LinkedIn';
export const SHARE_TEXT_COPYPASTE = 'Copier le lien dans le presse-papier';
export const SHARE_TEXT_COPYPASTE_SUCCESS = 'Lien copié dans le presse papier';

export const FOLLOW_TEXT = 'NOUS SUIVRE';

// Fiche client affichée dans la colonne, page par page.
// À tenir alignée avec PDF_MENU plus bas : les deux listes décrivent les mêmes
// sections. Une page absente d'ici s'affiche sans fiche (cas de la page 44).
export const TEXT_GROUPS = [
  {
    pages: [4, 5, 6, 7],
    client: "AGENCE DE LA BIOMÉDECINE",
    secteur: "Santé publique",
    miles: "",
  },
  {
    pages: [8, 9, 10],
    client: "UNICANCER",
    secteur: "Lutte contre le cancer",
    miles: "",
  },
  {
    pages: [11, 12, 13, 14, 15],
    client: "SANTÉ PUBLIQUE FRANCE",
    secteur: "Agence nationale de santé publique",
    miles: "",
  },
  {
    pages: [16, 17, 18],
    client: "ARS",
    secteur: "Agence nationale de santé publique",
    miles: "",
  },
  {
    pages: [19, 20, 21, 22],
    client: "HÔPITAL NATIONAL DES 15-20",
    secteur: "Ophtalmologie",
    miles: "",
  },
  {
    pages: [23, 24, 25],
    client: "PDS",
    secteur: "Plateforme nationale de données de santé",
    miles: "",
  },
  {
    pages: [26, 27, 28],
    client: "WHAT’S UP DOC",
    secteur: "Magazine dédié aux jeunes médecins",
    miles: "",
  },
  {
    pages: [29, 30, 31, 32],
    client: "ELSAN",
    secteur: "2<sup>ème</sup> groupe d'hospitalisation privée en France",
    miles: "",
  },
  {
    pages: [33, 34, 35, 36],
    client: "MEDECINES PATENT POOL",
    secteur: "Organisation internationale engagée dans la santé publique",
    miles: "",
  },
  {
    pages: [37, 38, 39],
    client: "HAUTE AUTORITÉ DE SANTÉ",
    secteur: "Santé publique",
    miles: "",
  },
  {
    pages: [40, 41, 42],
    client: "ANSES",
    secteur: "Évaluation des risques sanitaires, veille scientifique et appui à la décision publique",
    miles: "",
  },
  {
    pages: [43, 45, 46, 47, 48, 49, 50, 51],
    client: "À PROPOS DE LUCIOLE",
    secteur: "",
    miles: "",
  },
];

const createTextLinks = (groups) => groups.reduce((acc, { pages, ...content }) => {
  pages.forEach((page) => {
    acc[page] = { ...content };
  });
  return acc;
}, {});

export const TEXT_LINKS = createTextLinks(TEXT_GROUPS);

// Renvois du menu : première et dernière page de chaque section du PDF.
export const PDF_MENU = [
  {
    label: 'AGENCE DE LA BIOMÉDECINE',
    pages: [4, 7],
  },
  {
    label: 'UNICANCER',
    pages: [8, 10],
  },
  {
    label: 'SANTÉ PUBLIQUE FRANCE',
    pages: [11, 15],
  },
  {
    label: 'ARS',
    pages: [16, 18],
  },
  {
    label: 'HÔPITAL NATIONAL DES 15-20',
    pages: [19, 22],
  },
  {
    label: 'PDS',
    pages: [23, 25],
  },
  {
    label: 'WHAT’S UP DOC',
    pages: [26, 28],
  },
  {
    label: 'ELSAN',
    pages: [29, 32],
  },
  {
    label: 'MEDECINES PATENT POOL',
    pages: [33, 36],
  },
  {
    label: 'HAUTE AUTORITÉ DE SANTÉ',
    pages: [37, 39],
  },
  {
    label: 'ANSES',
    pages: [40, 42],
  },
  {
    label: 'À PROPOS DE LUCIOLE',
    pages: [43, 51],
  },
];

// GIF ou vidéo affiché dans la colonne, par numéro de page.
// Le PDF d'octobre 2026 n'en contient aucun.
export const LINKS = {}

// Bouton « Voir le site », par numéro de page.
// En double page, seule la page de gauche (paire) commande la colonne :
// un lien posé sur une page impaire n'y apparaît pas.
export const WEB_LINKS = {
  10: {
    url: "https://unicancer.fr/rapport-activite/2024/",
  },
  50: {
    url: "https://luciole.com/projets/",
  },
}

const SHARE_URL = encodeURIComponent(window.location.href);
const SHARE_DESCRIPTION = encodeURIComponent('Luciole');
const SHARE_TITLE = encodeURI('Luciole');
export const WEBSITE_URL = 'https://luciole.com/';
export const FACEBOOK_SHARE_PARAMS = `http://www.facebook.com/share.php?u=${SHARE_URL}`;
export const X_SHARE_PARAMS = `http://x.com/intent/tweet?text=${SHARE_DESCRIPTION}&url=${SHARE_URL}`;
export const LINKEDIN_SHARE_PARAMS = ` https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}&title=${SHARE_TITLE}&summary=${SHARE_DESCRIPTION}`;
export const LINKEDIN_URL = 'https://www.linkedin.com/company/agence-luciole';

const CONFIG = {
  PDF_NAME,
  SKIP_ANIMATION_STORAGE_KEY,
  MENU_DESKTOP_WIDTH,
  MENU_MOBILE_HEADER_HEIGHT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_PAGE_RATIO,
  NAVIGATION_HEIGHT,
  LINKS,
  MOBILE_NAVIGATION_HEIGHT,
  FACEBOOK_SHARE_PARAMS,
  X_SHARE_PARAMS,
  WEBSITE_URL,
};

export default CONFIG;
